import { render } from "./WorkConnection.vue?vue&type=template&id=3f2932d7"
import script from "./WorkConnection.vue?vue&type=script&lang=js"
export * from "./WorkConnection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../MemberPortal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__